import React from 'react';

const HitDefault = ({hit, localization}) => (
    <div className="hds-mt-32">Unknown hit category: {hit._category}</div>
);

export default HitDefault;
